import { useEffect, useState } from 'react'

import {
  isTrialPlan,
  useAccount,
  useAccountLoaders,
  useAccountWebsocket,
} from '@/modules/account'
import { captureException } from '@/services/monitoring/captureException'

const POLL_INTERVAL_MS = 3000
const SLOW_SETUP_MS = 60_000

// The card step returns here before Stripe's webhook may have started the trial. The account
// channel usually brings the change; polling covers a socket that never connects.
export const useWaitForTrial = () => {
  useAccountWebsocket()
  const { fetchAccount } = useAccountLoaders()
  const account = useAccount()
  const isLive = isTrialPlan(account?.planKind)
  const isRefused = Boolean(account?.trialRefusedReason)
  const [isSlow, setIsSlow] = useState(false)

  useEffect(() => {
    if (isLive || isRefused) return
    const checkAccount = () => fetchAccount()?.catch(captureException)
    checkAccount()
    const poll = setInterval(checkAccount, POLL_INTERVAL_MS)
    const slowNotice = setTimeout(() => setIsSlow(true), SLOW_SETUP_MS)
    return () => {
      clearInterval(poll)
      clearTimeout(slowNotice)
    }
  }, [isLive, isRefused, fetchAccount])

  return { isLive, isRefused, isSlow }
}
